// extracted by mini-css-extract-plugin
export default {"input":"lsf-input","textarea":"lsf-textarea","input__spinner":"lsf-input__spinner","waiting-spin":"lsf-waiting-spin","waiting":"lsf-waiting"};